
import Worker from '../workers/pdfWorker.js?worker';

class PDFEngineClass {
    constructor() {
        this.worker = new Worker();
        this.pending = new Map(); // messageId -> { resolve, reject }
        this.messageIdCounter = 0;

        this.worker.onmessage = (e) => {
            const { type, messageId, result, error } = e.data;

            if (this.pending.has(messageId)) {
                const { resolve, reject } = this.pending.get(messageId);
                this.pending.delete(messageId);

                if (type === 'SUCCESS') {
                    resolve(result);
                } else {
                    reject(new Error(error));
                }
            }
        };
    }

    _send(type, payload, transfer = []) {
        return new Promise((resolve, reject) => {
            const messageId = this.messageIdCounter++;
            this.pending.set(messageId, { resolve, reject });
            this.worker.postMessage({ type, payload, messageId }, transfer);
        });
    }

    async loadDocument(docId, file) {
        const buffer = await file.arrayBuffer();
        // We transfer the buffer to the worker
        return this._send('LOAD_DOCUMENT', { docId, buffer }, [buffer]);
    }

    async exportPdf(pages) {
        return this._send('EXPORT_PDF', { pages });
    }
}

export const PDFEngine = new PDFEngineClass();
